export default __webpack_public_path__ + "static/media/resume.fb81aa56.docx";